import ApplicationController from '../../support/application_controller'
import $fq                   from '../../support/fake_query'

export default class SimpleAssessmentController extends ApplicationController {

  static targets = [
    'hivConfirmationInconclusive',
    'hivTestResult',
    'pathologyTestDetails',
    'pathologyTestInput'
  ]

  static outlets = [
    'consultation'
  ]

  connect() {}

  initialize() {}

  disconnect() {}

  // ==== Actions

  renderResponse(event) {
    const [_response, _status, xhr] = event.detail

    $fq(this.consultationOutlet.responseBodyTarget).html(xhr.response)
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  resetInputs(inputs) {
    inputs.forEach((element) => {
      const type = element.getAttribute('type')

      if (type === 'checkbox' || type === 'radio') {
        element.checked = false
      } else {
        element.value = ''
      }
    })
  }

  togglePathologyTest() {
    if (!this.hasPathologyTestDetailsTarget) return

    const hivTestResult = this.hivTestResultTargets.find((radio) => radio.checked)
    const hivConfirmationInconclusive = this.hivConfirmationInconclusiveTargets.find((radio) => radio.checked)

    if (hivTestResult?.value === 'inconclusive' && hivConfirmationInconclusive?.value === 'inconclusive') {
      $fq(this.pathologyTestDetailsTarget).show()
    } else {
      this.resetInputs(this.pathologyTestInputTargets)
      $fq(this.pathologyTestDetailsTarget).hide()
    }
  }

  // ==== Channels

}
